<template>
  <div class="LKMunMehCardProgress">
    <div v-if="!isLoadingAsyncData" class="LKMunMehCardProgress__text" v-text="progressText" />
    <v-progress-linear
      class="LKMunMehCardProgress__progress"
      :value="lazyProgress"
      height="25"
      :indeterminate="isLoadingAsyncData"
    />
  </div>
</template>

<script>
import { lkPublicationsMapper } from '@/views/LKPublications/store'

export default {
  name: 'LKMunMehCardProgress',
  props: {
    munMehId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isLoadingAsyncData: false,
    progress: {
      to_mark_count: 0,
      is_marked_count: 0,
    },
  }),
  computed: {
    lazyProgress() {
      return (this.progress.is_marked_count / this.progress.to_mark_count) * 100
    },
    progressText() {
      return `Экспертиза: ${this.progress.is_marked_count} форм из ${this.progress.to_mark_count}`
    },
  },
  async created() {
    this.isLoadingAsyncData = true
    try {
      this.progress = await this.getMunMehFormsProgress(this.munMehId)
    } catch (e) {
      this.$notice.errors(e)
    }
    this.isLoadingAsyncData = false
  },
  methods: {
    ...lkPublicationsMapper.mapActions(['getMunMehFormsProgress']),
  },
}
</script>

<style lang="scss">
.LKMunMehCardProgress {
  margin-top: 16px;

  &__text {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: bold;
    color: $webflow-color-blue-dark-2;
  }

  &__progress {
    border-radius: 4px;
  }

  .v-progress-linear {
    &__buffer {
      background-color: $webflow-color-grey;
    }

    .primary {
      background-color: $webflow-color-green;
    }
  }
}
</style>
